export default {
  brandpartners: {
    subtitle: "شركاؤنا",

    title1: "موثوق من قبل",
    title2: "أبرز العلامات الغذائية",

    desc:
      "نتعاون مع موردين وعلامات تجارية موثوقة لضمان جودة ثابتة وتوريد موثوق.",

    cta: "كن شريكًا",
  },
};